import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@material-ui/core'
import { Page, Header } from 'components'
import { useExameSolicitadoService } from 'hooks/useExameSolicitadoService'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useRouter from 'utils/useRouter'

import useStyles from './styles'

import { FormAdicionarExame } from '../Componentes/ExamesSolicitados/FormAdicionarExame'
import { useParams } from 'react-router'

export const EditarExameSolicitado = (props) => {
  const router = useRouter()
  const { route } = props
  const exameSolicitadoService = useExameSolicitadoService()
  const solicitacaoExameService = useSolicitacaoExameService()
  const params = useParams()
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const [exameSolicitado, setExameSolicitado] = useState(null)
  const [solicitacaoExame, setSolicitacaoExame] = useState(null)
  const [processandoExameSolicitado, setProcessandoExameSolicitado] = useState(false)

  const fetchExameSolicitado = useCallback(async () => {
    if (params.id) {
      setProcessandoExameSolicitado(true)
      const result = await exameSolicitadoService.listarExameSolicitadoAsync(params.id)
      setExameSolicitado(result)
      setProcessandoExameSolicitado(false)
    }
  }, [params])

  const fetchSolicitaoExame = useCallback(async () => {
    if (params.idSolicitacao) {
      setProcessandoExameSolicitado(true)
      const result = await solicitacaoExameService.listarSolicitacaoExameAsync(params.idSolicitacao)
      setSolicitacaoExame(result)
      setProcessandoExameSolicitado(false)
    }
  }, [params])

  useEffect(() => {
    fetchSolicitaoExame()
  }, [fetchSolicitaoExame])
  useEffect(() => {
    fetchExameSolicitado()
  }, [fetchExameSolicitado])

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />
      {processandoExameSolicitado ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <FormAdicionarExame exameSolicitado={exameSolicitado} editar={true} route={route} idCaso={exameSolicitado?.solEx.id_caso || solicitacaoExame?.id_caso} />
      )}
    </Page>
  )
}
